export default __webpack_public_path__ + "static/media/project.ad14763a.png";